import { useContext } from 'react';
import { Home_context } from '../../context/home_context';

export default function Applications() {
  const { report_data_state } = useContext(Home_context);

  return (
    <div className="flex  pt-[1%]">
      <p className=" non_table_block_padding text-start font-semibold min-w-fit page_pera_font_size sub_header_color ">
        Applications / Concepts :{' '}
      </p>
      <div className="flex gap-2 items-center">
        {report_data_state?.report_data['properties'].split(',')?.map((el) => (
          <span className="text-start page_pera_font_size titles_cards ">
            {el}
          </span>
        ))}
      </div>
    </div>
  );
}
